<template>
  <main>
    <b-container>
      <div class="section-header">
        <div>
          <h1 class="m-0">Realms</h1>
        </div>

        <div class="actions">
          <div class="action">
            <b-form-input
              v-model="searchRealm"
              placeholder="Search…"
              class=""
            ></b-form-input>
          </div>
          <div class="action">
            <b-btn variant="primary" @click="$router.push({ name: 'AddRealm' })"><i class="fa fa-plus" /> New realm</b-btn>
          </div>
        </div>
      </div>

      <b-row>
        <b-col>
          <div class="layoutcard">
            <!-- This table is for loading placeholders.
            Use this when you implement lazy loading. -->
            <!-- <table class="table table-hover vertical-align-middle">
              <thead>
                <tr>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">users
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table> -->

            <b-table
              :show-empty="true"
              :items="realms"
              :fields="fieldsRealms"
              :filter="searchRealm"
              :current-page="currentPageRealm"
              :per-page="perPage"
              :sort-by="'companyname'"
              class="table-hover vertical-align-middle"
            >
              <template v-slot:cell(user_name)="data">
                <router-link
                  :to="{ name: 'UserView', params: { id: data.item._id } }"
                  >{{ data.item.companyname }}</router-link
                >
              </template>

              <!--
              <template v-slot:cell(projects)="data">
                {{ getUserProjects(data.item) }}
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn-group>
                  <b-btn variant="link-dark" size="sm" @click="confirmDelete(data.item)" class="ml-1">
                    <i class="fa fa-trash" />
                  </b-btn>
                </b-btn-group>
              </template>
              -->
            </b-table>

            <b-row align-h="center" class="mt-4" v-if="totalRowsRealms > perPage">
              <b-pagination
                v-model="currentPageRealm"
                :total-rows="totalRowsRealms"
                :per-page="perPage"
              ></b-pagination>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <div class="section-header">
        <div>
          <h1 class="m-0">Users</h1>
        </div>

        <div class="actions">
          <div class="action">
            <b-form-input
              v-model="searchUser"
              placeholder="Search…"
              class=""
            ></b-form-input>
          </div>
          <div class="action">
            <b-btn variant="primary" @click="$router.push({ name: 'AddRealmUser' })"><i class="fa fa-plus" /> New user</b-btn>
          </div>
        </div>
      </div>

      <b-row>
        <b-col>
          <div class="layoutcard">
            <!-- This table is for loading placeholders.
            Use this when you implement lazy loading. -->
            <!-- <table class="table table-hover vertical-align-middle">
              <thead>
                <tr>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                  <th>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                  <td>
                    <div class="placeholder">
                      <div class="placeholder__tile"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table> -->

            <b-table
              :show-empty="true"
              :items="realmUsers"
              :fields="fieldsUsers"
              :filter="searchUser"
              :current-page="currentPageUser"
              :per-page="perPage"
              :sort-by="'username'"
              class="table-hover vertical-align-middle"
            >
              <template v-slot:cell(username)="data">
                <router-link
                  :to="{ name: 'UserView', params: { id: data.item._id } }"
                  >{{ data.item.username }}</router-link
                >
              </template>

              <template v-slot:cell(firstName)="data">
                {{
                  data.item.firstName == "null null"
                    ? "---"
                    : data.item.firstName
                }}
              </template>
              <template v-slot:cell(status)="data">
                <b-badge v-if="data.item.status !== 'Active'" variant="danger">Blocked</b-badge>
                <b-badge v-else-if="data.item.login_status" variant="success">Online</b-badge>
                <b-badge v-else variant="light">Offline</b-badge>
              </template>
              <template v-slot:cell(role)="data">
                 <i class="fa" :class="{ 'fa-key text-warning': data.item.role==='admin', 'fa-star text-info': data.item.role==='normal', 'fa-eye text-grey': data.item.role==='discover' }" /> {{ data.item.role }}
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn-group>
                  <b-btn variant="link-dark" size="sm" @click="confirmUpdate(data.item)" class="ml-1">
                    <i class="fa fa-key" />
                  </b-btn>
                  <b-btn variant="link-dark" size="sm" @click="editUser(data.item)" class="ml-1">
                    <i class="fa fa-edit" />
                  </b-btn>
                  <b-btn variant="link-dark" size="sm" @click="AllowUser(data.item)" class="ml-1" v-if="data.item.status!=='Active'">
                    <i class="fa fa-ban" />
                  </b-btn>
                  <b-btn v-else variant="link-dark" size="sm" @click="BlockUser(data.item)" class="ml-1">
                    <i class="fa fa-check" />
                  </b-btn>
                </b-btn-group>
              </template>
            </b-table>

            <b-row align-h="center" class="mt-4" v-if="totalRowsUsers > perPage">
              <b-pagination
                v-model="currentPageUser"
                :total-rows="totalRowsUsers"
                :per-page="perPage"
              ></b-pagination>
            </b-row>
          </div>
        </b-col>
      </b-row>

    </b-container>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "UserIndex",
  extends: InitAdmin,
  data() {
    return {
      searchUser: "",
      searchRealm: "",
      currentPageUser: 1,
      currentPageRealm: 1,
      perPage: 10,
      fieldsRealms: [
        {
          key: "companyname",
        },
        {
          key: "employees",
        },
        {
          key: "created",
        }
      ],
      fieldsUsers: [
        {
          key: "username",
        },
        {
          key: "email",
        },
        {
          key: "company",
        },
        {
          key: "role",
        },
        {
          key: "status",
        },
        {
          key: "created",
        },
        {
          key: "actions",
        }
      ],
    };
  },
  computed: {
    ...mapGetters([]),
    ...mapState({
      realms: (state) => state.realm.realms,
      realmUsers: (state) => state.realm.realmUsers
    }),
    totalRowsUsers() {
      return this.realmUsers ? this.realmUsers.length : null;
    },
    totalRowsRealms() {
      return this.realms ? this.realms.length : null;
    }
  },
  mounted() {
    this.loadRealms();
    this.loadUsers();
  },
  methods: {
    ...mapActions(["loadRealms", "loadUsers", "updateUserPass", "passEmail", "updateUserStatus"]),
    generatePassword() {
      let length = 8,
          charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
          retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
    sendUserEmail(item, pass){
      /*let data = {
        service_id: 'service_tlmk8lw',
        template_id: 'template_uwgbxju',
        user_id: 'S_uWT9jB0lgBTRj-m',
        template_params: {
            'username': item.username,
            'name': item.firstName + ' ' + item.lastName,
            'email': item.email,
            'password': pass,
            'url': 'https://dev.mynd-ware.com'
        }
      }*/
      let data = {
        email: item.email,
        name: item.firstName + ' ' + item.lastName,
        temppass: pass,
        purpose: "reset"
      }
      this.passEmail(data).then(() => {
        this.$toasted.show("Email sent with temp credentials to "+item.email, {
            type: "success",
        });
      })
    },
    confirmUpdate(item) {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to reset password for the User “${item.username}”?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (value) {
            console.log(item)
            let pass = this.generatePassword();
            this.updateUserPass({id: item._id, password: pass}).then(res => {
              this.sendUserEmail(item, pass);
            })
          }
        });
    },
    BlockUser(item) {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to block this user?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (value) {
            this.updateUserStatus({user_id: item._id, status: "InActive"}).then(() => {
              this.$toasted.show("User blocked successfully", {
                  type: "success",
              });
              this.loadUsers();
            })
          }
        });
    },
    AllowUser(item) {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to allow this user?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (value) {
            this.updateUserStatus({user_id: item._id, status: "Active"}).then(() => {
              this.$toasted.show("User allowed successfully", {
                  type: "success",
              });
              this.loadUsers();
            })
          }
        });
    },
    editUser(item) {
      this.$router.push({ name: "UpdateRealmUser", params : { id: item._id }})
    }
  },
};
</script>